import { render, staticRenderFns } from "./ClientNewProject.vue?vue&type=template&id=adab0a38&scoped=true&"
import script from "./ClientNewProject.vue?vue&type=script&lang=js&"
export * from "./ClientNewProject.vue?vue&type=script&lang=js&"
import style0 from "./ClientNewProject.vue?vue&type=style&index=0&id=adab0a38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adab0a38",
  null
  
)

export default component.exports